/* eslint-disable indent */
import algoliasearch from 'algoliasearch/lite';
import { CREDENTIALS as AlgoliaCredantials } from '../config/algolia';

import { stopScrolling, startScrolling, locale } from '../alpine-functions';

const BASE_URL = '/api/v1/dictionary';

const NON_ALPHABETICAL_KEY = '0-99';

export default () => ({
  algoliaClient: null,
  currentLetter: 'A',
  dictionary: [],
  filteredDictionary: [],
  indexDictionary: {},
  selectedMethodics: [],
  initialGroup: [],
  query: '',
  searchResults: [],
  loaded: false,
  groupedData: null,

  setGroupedData() {
    const grouped = {};
    for (const curr of this.filteredDictionary) {
      const firstLetter = curr[`first_letter_${locale()}`];
      const key = /^[a-zA-Z]/.test(firstLetter)
        ? firstLetter
        : NON_ALPHABETICAL_KEY;
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(curr);
    }

    this.groupedData = grouped;

    if (this.selectedMethodics.length) {
      const keys = Object.keys(grouped);
      if (keys.length > 0) {
        const firstKey = keys[0];
        this.currentLetter = firstKey;
      }
    } else {
      this.currentLetter = 'A';
    }
  },

  hasGroupedData(letter) {
    if (!this.groupedData) {
      return false;
    }
    return letter in this.groupedData;
  },

  get searching() {
    return this.query.length > 2;
  },

  setLetter(letter) {
    this.currentLetter = letter;
  },

  fetchData() {
    fetch(`${BASE_URL}`)
      .then((response) => response.json())
      .then((response) => {
        this.dictionary = response.data;
        this.filteredDictionary = response.data;
        this.setGroupedData();
        this.loaded = true;
      });
  },

  searchQuery() {
    this.searching = true;
    this.indexDictionary.search(this.query).then(({ hits }) => {
      this.searchResults = hits;
    });
  },

  setMethodics(slug) {
    const index = this.selectedMethodics.indexOf(slug);
    if (index !== -1) {
      this.selectedMethodics.splice(index, 1);
      if (this.selectedMethodics.length === 0) {
        this.filteredDictionary = this.dictionary;
      } else {
        this.filteredDictionary = this.filteredDictionary.filter(
          (item) => item.methodics.slug !== slug
        );
      }
    } else {
      this.selectedMethodics.push(slug);
      if (this.selectedMethodics.length === 1) {
        this.filteredDictionary = this.dictionary.filter(
          (item) => item.methodics.slug === slug
        );
      } else {
        const filtered = this.dictionary.filter((item) =>
          this.selectedMethodics.includes(item.methodics.slug)
        );
        this.filteredDictionary =
          filtered.length > 0 ? filtered : this.dictionary;
      }
    }

    this.setGroupedData();
  },

  getFilteredCountByMethodic(slug) {
    return this.filteredDictionary.filter(
      (item) => item.methodics.slug === slug
    ).length;
  },

  init() {
    this.fetchData();

    this.algoliaClient = algoliasearch(
      AlgoliaCredantials.app,
      AlgoliaCredantials.key
    );
    this.indexDictionary = this.algoliaClient.initIndex('DICTIONARY');

    this.$watch('query', () => {
      if (this.searching) {
        this.searchQuery();
      }
    });
  },
});
